import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// TODO:: Add set parameter support / upgrade to react-router-dom@v6 to deprecate this - @wesley.loh
const useSearchParams = () => {
  const location = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ]);

  return [searchParams];
};

export default useSearchParams;
